import { createContext, useContext, useState } from 'react'

import { BodyInspectionPatientStatus } from '@/modules/bodyInspection/domain/models/BodyInspectionPatientStatus'
import { LesionDiscoveryMoment } from '@/modules/bodyInspection/domain/models/LesionDiscoveryMoment'
import { LesionIntensity } from '@/modules/bodyInspection/domain/models/LesionIntensity'

const BodyInspectionContext = createContext<{
  filter: {
    bodyInspectionStatus: BodyInspectionPatientStatus | undefined
    lesionMoment: LesionDiscoveryMoment | undefined
    lesionIntensity: LesionIntensity | undefined
  }
  setBodyInspectionStatus: React.Dispatch<
    React.SetStateAction<BodyInspectionPatientStatus | undefined>
  >
  setLesionMoment: React.Dispatch<
    React.SetStateAction<LesionDiscoveryMoment | undefined>
  >
  setLesionIntensity: React.Dispatch<
    React.SetStateAction<LesionIntensity | undefined>
  >
}>({
  filter: {
    bodyInspectionStatus: undefined,
    lesionMoment: undefined,
    lesionIntensity: undefined
  },
  setBodyInspectionStatus: () => {},
  setLesionMoment: () => {},
  setLesionIntensity: () => {}
})

export const useBodyInspectionContext = () => useContext(BodyInspectionContext)

export function BodyInspectionProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [lesionMoment, setLesionMoment] = useState<
    LesionDiscoveryMoment | undefined
  >('IMMEDIATE')
  const [bodyInspectionStatus, setBodyInspectionStatus] = useState<
    BodyInspectionPatientStatus | undefined
  >(undefined)
  const [lesionIntensity, setLesionIntensity] = useState<
    LesionIntensity | undefined
  >(undefined)

  return (
    <BodyInspectionContext.Provider
      value={{
        filter: {
          bodyInspectionStatus,
          lesionMoment,
          lesionIntensity
        },
        setBodyInspectionStatus,
        setLesionMoment,
        setLesionIntensity
      }}
    >
      {children}
    </BodyInspectionContext.Provider>
  )
}
